import 'babel-polyfill'
require('promise.prototype.finally').shim()
require('promise.allsettled').shim()

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/plugins/index'
import '@/directive/index'

import '@/styles/index.scss'
import '@/utils/onResize'
import '@/assets/font/iconfont/iconfont.css'
import './permission.js'

// 控制vue调试工具
const isDebug_mode = process.env.NODE_ENV.indexOf('local') > -1
Vue.config.debug = isDebug_mode
Vue.config.devtools = isDebug_mode
Vue.config.productionTip = isDebug_mode

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
